import appStore from "../app-store"

export default class AppSession {
    // To store all app session data in memory for faster access
    // Currently, only auth data is store in this session
    static authData = appStore.getState().auth;
    static userGeolocation = {
        Longitude: 105.7982996,
        Latitude: 21.0324549
    };
    static currentStore = {
        StoreId: null,
        StoreInfo: null
    };

    /**
     * Get the current store
     * @returns {*}
     */
    static getCurrentStore() {
        return this.currentStore;
    }

    /**
     * To set current store
     * @param store
     */
    static setCurrentStore(store) {
        this.currentStore = {
            StoreId: store.Uuid,
            StoreInfo: store
        };
        //Save the selected store into the local storage
        localStorage.setItem('store', JSON.stringify(this.currentStore));
    }

    /**
     * Return authorization user data
     * @returns {*}
     */
    static auth() {
        return this.authData;
    }

    /**
     * Set authorization info
     * @param auth
     */
    static setAuth(auth) {
        this.authData = auth;
    }

    /**
     * Get current user geolocation
     * @returns {{Latitude: number, Longitude: number}}
     */
    static geolocation() {
        return this.userGeolocation;
    }

    /**
     * Set current user geolocation
     * @param geo
     */
    static setGeolocation(geo) {
        this.userGeolocation = geo;
    }

}
